module.exports = __webpack_public_path__ + "static/media/pencil-simple-line-fill.3ca7f40d.svg";